<script setup lang="ts">
import { ref, computed } from 'vue'
import { SearchIcon } from '@/components/icons'
const searchValue = ref<string>('')
const emit = defineEmits(['update:search'])
const updateSearch = () => {
  emit('update:search', searchValue.value)
}
const clearSearch = () => {
  searchValue.value = ''
  emit('update:search', '')
}
const showClearButton = computed(() => searchValue.value.length > 0)
</script>

<template>
  <div class="search-bar">
    <SearchIcon />
    <input
      type="text"
      placeholder="Search..."
      v-model="searchValue"
      @input="updateSearch"
    />
    <button 
      v-if="showClearButton" 
      class="clear-button" 
      @click="clearSearch"
      aria-label="Clear search"
    >
      <span class="cross">×</span>
    </button>
  </div>
</template>

<style scoped>
.search-bar {
  position: relative;
  opacity: 0.5;
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  height: 2.1875rem;
}
.search-bar::after {
  content: '';
  position: absolute;
  border-bottom: 0.09375rem solid var(--color-text);
  opacity: 0.15;
  width: 100%;
  bottom: 0;
  left: 0;
}
.search-bar > input {
  width: 100%;
  font-size: var(--font-size-small);
  font-style: italic;
  color: var(--color-text);
}
.search-bar > input::placeholder {
  color: var(--color-text);
  opacity: 0.75;
}
.clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-text);
  opacity: 0.7;
  padding: 0;
  margin-right: 0.125rem;
}
.clear-button:hover {
  opacity: 1;
}
.cross {
  font-size: var(--font-size-body);
  font-weight: 300;
  line-height: 1;
}
</style>